export default "__VITE_ASSET__RbtjLKyH__"